import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
export class AutocompleteService {
/**
 * @param {?} http
 */
constructor(private http: HttpClient) { }
/**
 * @param {?} url
 * @return {?}
 */
getData(url: string): Observable<Object[]> {
    return this.http.get(url)
      .map(res => {
        return res;
      })
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
];
}

function AutocompleteService_tsickle_Closure_declarations() {
/** @type {?} */
AutocompleteService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AutocompleteService.ctorParameters;
/** @type {?} */
AutocompleteService.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
